import { render, staticRenderFns } from "./tabComponets.vue?vue&type=template&id=a575059e"
import script from "./tabComponets.vue?vue&type=script&lang=js"
export * from "./tabComponets.vue?vue&type=script&lang=js"
import style0 from "./tabComponets.vue?vue&type=style&index=0&id=a575059e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports